export const GET_BLOG_LIST = 'GET_BLOG_LIST';
export const GET_COMMENT = 'GET_COMMENT';
export const ADD_COMMENT = 'ADD_COMMENT';
export const SELECTED_LOCATION = 'SELECTED_LOCATION';
export const SET_DATE = 'SET_DATE';
export const SET_TIME = 'SET_TIME';
export const BOOKED_DEMO = 'BOOKED_DEMO';